import Login from "./index.vue";
import ApiManager from '../core/api/index';

export function getGameLoginInfo(token: string) {
  return ApiManager.getInstance().user
    .getGameLoginInfo(token);
};

export function getUserInfo(token: string) {
  return ApiManager.getInstance().user
    .getUserInfo(token);
}

export { Login };
export default Login;
